const breadCrumbContainer = document.querySelector('.page-template__breadcrumb');

if (breadCrumbContainer) {

    //Vérifier si la taille du container est plus grande que la taille de l'écran
    //Si le breadcrumb est plus grand que l'écran , tous les éléments avant les deux derniers éléments sont cachés dans un dropdown menu
    //Le bouton pour affiché le dropdown menu sera un élément du breadcrumb qui contiendra '...' 

    const breadCrumbItems = breadCrumbContainer.querySelectorAll('.page-template__breadcrumb-list-item');
    const breadCrumbItemsArray = Array.from(breadCrumbItems);


    if (breadCrumbItemsArray.length >= 4) {
        //On cache tous les éléments avant les deux derniers éléments et on les met dans un dropdown menu
        const breadCrumbItemsToHide = breadCrumbItemsArray.slice(1, -2);
        const breadCrumbItemsToHideArray = Array.from(breadCrumbItemsToHide);
        const breadCrumbItemsToHideArrayLength = breadCrumbItemsToHideArray.length;

        const firstChildLi = breadCrumbItemsArray[0];
        let clonedItems = [];

        breadCrumbItemsToHideArray.forEach((item) => {
            //On récupère la flèche qui suis l'élément à cacher
            const arrow = item.nextElementSibling;
            arrow.style.display = 'none';

            clonedItems.push(item.cloneNode(true));
            item.style.display = 'none';
        });

        console.log(clonedItems);

        //On créer l'élément DANS le breadcrumb qui prend la place des deux autres éléments cachés et qui servira à ouvrir le dropdown menu
        const breadCrumbDropDownButton = document.createElement('span');
        breadCrumbDropDownButton.classList.add('page-template__breadcrumb-list-item');

        const breadCrumbDropDownButtonLink = document.createElement('a');
        breadCrumbDropDownButtonLink.setAttribute('href', '#');
        breadCrumbDropDownButtonLink.classList.add('page-template__breadcrumb-list-link');
        breadCrumbDropDownButtonLink.innerHTML = '...';



        breadCrumbDropDownButton.appendChild(breadCrumbDropDownButtonLink);

        //On créer le dropdown menu
        const breadCrumbDropDownMenu = document.createElement('ul');
        breadCrumbDropDownMenu.classList.add('page-template__breadcrumb-dropdown-menu');
        breadCrumbDropDownMenu.classList.add('page-template__breadcrumb-list');

        //On ajoute les éléments cachés dans le dropdown menu
        clonedItems.forEach((item) => {
            breadCrumbDropDownMenu.appendChild(item);
        });
        breadCrumbDropDownButton.appendChild(breadCrumbDropDownMenu);

        //On ajoute le dropdown menu dans le breadcrumb
        breadCrumbContainer.appendChild(breadCrumbDropDownButton);

        //On ajoute l'élément qui ouvre le dropdown menu dans le breadcrumb à la position après le premier élément
        firstChildLi.after(breadCrumbDropDownButton);

        const arrowIcon = '<li><svg class="breadcrumb-chevron" stroke - width="2" viewBox = "0 0 24 24" fill = "none" xmlns = "http://www.w3.org/2000/svg"><path d="M9 6L15 12L9 18" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg ></li>'
        firstChildLi.insertAdjacentHTML('afterend', arrowIcon);


        breadCrumbDropDownButtonLink.addEventListener('click', (e) => {
            e.preventDefault();
            breadCrumbDropDownMenu.classList.toggle('page-template__breadcrumb-dropdown-menu--open');
            
        });

    }




}